module.exports = __webpack_public_path__ + "img/tcoin-icon.1552376.png";